"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.releaseOrderToWorkflow = void 0;
const getOrderById_1 = require("./getOrderById");
const updateOrderStatus_1 = require("./updateOrderStatus");
const updateOrder_1 = require("./updateOrder");
const helpers_1 = require("../../helpers");
const __1 = require("..");
const releaseOrderToWorkflow = async (supabase, order_id) => {
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
    const variant = order?.variants?.find((variant) => variant.id === order.default_variant_id);
    const non_primary_variants = order?.variants?.filter((variant) => variant.id !== order.default_variant_id);
    // archive all non-primary variants
    if (non_primary_variants && non_primary_variants?.length > 0) {
        for (let i = 0; i < non_primary_variants?.length || 0; i++) {
            const non_primary_variant = non_primary_variants[i];
            await supabase
                .from("order_variants")
                .update({ archived: true })
                .eq("id", non_primary_variant.id);
        }
    }
    if (!variant) {
        throw new Error("Default variant not found in order");
    }
    const hotel_lines = variant?.order_lines?.filter((line) => line.type === "HOTEL");
    // put the order into AUTOMATIC mode
    order.mode = "AUTOMATIC";
    await (0, updateOrder_1.updateOrder)(supabase, order);
    if (hotel_lines && hotel_lines?.length > 0) {
        await (0, updateOrderStatus_1.updateOrderStatus)(supabase, order, "CONFIRMING_HOTELS");
    }
    else {
        await (0, updateOrderStatus_1.updateOrderStatus)(supabase, order, "CONFIRMING_GOLF");
    }
    if (variant?.order_lines) {
        // update all lines that are draft to pending
        for (let i = 0; i < variant?.order_lines?.length || 0; i++) {
            const order_line = variant?.order_lines[i];
            if (order_line.status === helpers_1.OrderLineStatus.DRAFT) {
                await (0, __1.updateOrderLineStatus)(supabase, order_line.id, helpers_1.OrderLineStatus.PENDING);
            }
        }
    }
};
exports.releaseOrderToWorkflow = releaseOrderToWorkflow;
